import React from "react";
import {
  Box,
  CssBaseline,
  Grid,
  ThemeProvider,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import Common from "./Common";
import Ledgerhome from "../../../assets/Ledgerhome.png";
import Dockethome from "../../../assets/Dockethome.png";

const gridData = [
  {
    imgSrc: Dockethome,
    title: "Docket",
    subtitle:
      "Take control of academy organization with a single click - say hello to seamless success!",
    borderColor: "#7317B9",
    color: "#7317B9",
    marginTop: "1.999375rem",
    link: "/docket",
  },
  {
    imgSrc: Ledgerhome,
    title: "Ledger",
    subtitle: "Revamp your cash management with our sleek register!",
    borderColor: `${theme.palette.primary.main}`,
    color: `${theme.palette.primary.main}`,
    marginTop: "3.499375rem",
    link: "/ledger",
  },
];

const Others = () => {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: isSm ? "3.75rem" : "7.5rem",
          marginBottom: isSm ? "3.75rem" : "7.5rem",
          marginLeft: isSm ? "0.75rem" : "10.25rem",
          marginRight: isSm ? "0.75rem" : "10.25rem",
        }}
      >
        <Grid container spacing={isSm ? 5 : 13}>
          {gridData.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Common
                title={item.title}
                subtitle={item.subtitle}
                imgSrc={item.imgSrc}
                borderColor={item.borderColor}
                color={item.color}
                marginTop={item.marginTop}
                link={item.link}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </ThemeProvider>
  );
};

export default Others;